import { Formik } from "formik";

import FormDisplay from "./FormDisplay";

export default function Form({
  audiences,
  formData,
  editState,
  setEditState,
  audienceData,
  categories,
  connections,
  brandDetails,
  component,
  setBrandDetails,
  setConnections,
  setRetry,
  retry,
  connectionRealStats,
  setConnectionRealStats,
}) {
  return (
    <Formik enableReinitialize initialValues={formData} validateOnMount>
      {(formikProps) => (
        <FormDisplay
          setConnections={setConnections}
          editState={editState}
          setEditState={setEditState}
          categories={categories}
          brandDetails={brandDetails}
          audienceData={audienceData}
          formikProps={formikProps}
          audiences={audiences}
          connections={connections}
          component={component}
          setBrandDetails={setBrandDetails}
          setRetry={setRetry}
          retry={retry}
          connectionRealStats={connectionRealStats}
          setConnectionRealStats={setConnectionRealStats}
        />
      )}
    </Formik>
  );
}
